import { getIsInternalUser } from '@aline/common';
import { isDev } from 'src/config';
import { useSelectCurrentUser } from 'src/gql/hooks/user';

export const PLANNED_MENU_ITEMS_FLAG = isDev;

export const Flag = {
  AUTO_GENERATE_QUESTIONS: false,
  // This is set to fale on the Server.  If we change, ensure to change here and on Server and vice versa.
  AUTO_RUN_CORE_AI_STANDARD_PROPERTIES: false,
  GET_STARTED_ADVANCED: false,
  /**
   * The /get-started onboarding experience is broken, so it is hidden from customers
   * until it is fixed.
   */
  GET_STARTED_ONBOARDING: isDev,
  /**
   * Per-position comment guidance on playbook authoring. Off until that UI
   * ships; the field still exists on the position in the API.
   */
  PLAYBOOK_COMMENT_GUIDANCE: false,
  V2_MENTION_TYPES: isDev,
};

export function useIsInternalUser(): boolean {
  const currentUser = useSelectCurrentUser();
  return getIsInternalUser(currentUser?.email);
}

export function useIsAlineDomainUser(): boolean {
  const currentUser = useSelectCurrentUser();
  return Boolean(currentUser?.email?.endsWith('@aline.co'));
}

// Environment-based feature flags
export const enablePartyMentions: boolean = process.env.ENABLE_PARTY_MENTIONS === '1';
